import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { Container, Row, Col, Card, CardImg, CardBody, CardTitle, CardText } from "reactstrap";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import DefaultFooter from "../../components/Footers/DefaultFooter";

const BlogDetailPage = () => {
    const { photoTitle } = useParams();
    const [post, setPost] = useState(null);

    const getPost = async () => {
        const response = await Axios.get(`${process.env.REACT_APP_API_URL}/blog/readBlog`);
        const posts = response.data;
        const foundPost = posts.find(
            (p) =>
                generateSlug(p.title) === photoTitle ||
                generateSlug(p.title_foto_satu) === photoTitle ||
                generateSlug(p.title_foto_dua) === photoTitle ||
                generateSlug(p.title_foto_tiga) === photoTitle
        );
        setPost(foundPost);
    };

    useEffect(() => {
        getPost();
    }, [photoTitle]);

    const generateSlug = (title) => {
        return title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
    };

    if (!post) return <div>Loading...</div>;

    const getPhotoDetails = () => {
        switch (photoTitle) {
            case generateSlug(post.title):
                return {
                    title: post.title,
                    image: post.foto_main,
                    description: post.detail_foto_main,
                    date: post.tanggal_foto_main,
                };
            case generateSlug(post.title_foto_satu):
                return {
                    title: post.title_foto_satu,
                    image: post.foto_satu,
                    description: post.detail_foto_satu,
                    date: post.tanggal_foto_satu,
                };
            case generateSlug(post.title_foto_dua):
                return {
                    title: post.title_foto_dua,
                    image: post.foto_dua,
                    description: post.detail_foto_dua,
                    date: post.tanggal_foto_dua,
                };
            case generateSlug(post.title_foto_tiga):
                return {
                    title: post.title_foto_tiga,
                    image: post.foto_tiga,
                    description: post.detail_foto_tiga,
                    date: post.tanggal_foto_tiga,
                };
            default:
                return null;
        }
    };

    const photoDetails = getPhotoDetails();
    if (!photoDetails) return <div>Photo not found...</div>;

    return (
        <>
            <ExamplesNavbar />
            <Container className="detail-media" style={{ marginTop: "120px" }}>
                <Row className="justify-content-center">
                    <Col md="8">
                        <Card className="post-detail-page">
                            <CardImg
                                top
                                width="100%"
                                src={photoDetails.image}
                                alt={photoDetails.title}
                                className="image-media"
                            />
                            <CardBody>
                                <CardTitle tag="h3" className="title-media">
                                    {photoDetails.title}
                                </CardTitle>
                                <CardText className="date-media">
                                    {new Date(photoDetails.date).toLocaleDateString()}
                                </CardText>
                                <CardText className="desc-media">
                                    {photoDetails.description}
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <DefaultFooter />
        </>
    );
};

export default BlogDetailPage;
